import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { manageDsrZoomLink } from '../../organizations/actions/zoom-actions';
import DefaultSpinner from '../../global/components/helper-components/components/DefaultSpinner';
import { Flex } from '@chakra-ui/react';

function DsrDeleteZoomLinkLink({
  //Parent Component
  dsrId,
  // Actions
  manageDsrZoomLink,
  // Redux
  isDsrAdmin,
  authorisedExternalIntegrations
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [allowDeleteLink, setAllowDeleteLink] = useState(false)

  useEffect(() => {
    if (isDsrAdmin && authorisedExternalIntegrations) {
      const { authorisedZoom } = authorisedExternalIntegrations || {}
      if (authorisedZoom === true) {
        setAllowDeleteLink(true)
      }
    }
  }, [isDsrAdmin, authorisedExternalIntegrations]);

  const deleteZoomLinkForDsr = () => {
    manageDsrZoomLink({
      sourceEvent: "delete-zoom-link",
      dsrId
    })
    setIsLoading(true)
  }

  if (allowDeleteLink) {
    if (isLoading) {
      return <Flex justify='center' mt='0.5em'><DefaultSpinner /></Flex>
    } else {
      return (
        <Flex color='gray.500' mt='0.5em' w='100%' cursor='pointer' fontSize='0.7em' justify='center' onClick={() => deleteZoomLinkForDsr()} >
          Remove meeting link
        </Flex>
      )
    }
  } else return null;
};


function mapStateToProps(state) {
  return {
    authorisedExternalIntegrations: state.authorisedExternalIntegrationsConfig.results,
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageDsrZoomLink
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrDeleteZoomLinkLink));
